'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _departureServicesDataActions = require('actions/departureServicesDataActions');

var _requirementDataActions = require('actions/requirementDataActions');

var _utilityFunctions = require('utils/utilityFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// departureServices resources are stored by id
function departureServices() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _requirementDataActions.REQUIREMENT_DATA_RECEIVED:
            // We only get id and href inside this normalized customers object from this action
            // (so we don't want to overwrite any additional data obtained from DEPARTURE_SERVICES_DATA_RECEIVED)
            return (0, _extends3.default)({}, action.requirementData.departure_services, state);
        case _departureServicesDataActions.DEPARTURE_SERVICES_DATA_RECEIVED:
            return (0, _extends3.default)({}, state, (0, _utilityFunctions.reduceResourceArrayToObjById)(action.newDepartureServicesData, 'id'));
        default:
            return state;
    }
}

exports.default = departureServices;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/departureServices.js
// module id = 1397
// module chunks = 0